import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion"
import { ReceiptText } from "lucide-react"
import DiscountedFee from "./components/discounted-fee"
import { usePayment } from "./use-payment"
import { useFormStore } from "@/stores/use-form-store"
// import { useEffect } from "react"
// import { useFormStore } from "@/stores/use-form-store"
import { useShallow } from "zustand/react/shallow"
import { useMemo, useState } from "react"
// import { useState } from "react"

interface SummaryProps {
	description?: string
	nameYourPaymentPlan?: string
}

const Summary = ({ description, nameYourPaymentPlan }: SummaryProps) => {
	const { applicationId } = useFormStore(
		useShallow(state => {
			return {
				applicationId: state.applicationId,
			}
		}),
	)

	const isPreviewMode = !applicationId || applicationId === ""

	// useEffect(() => {
	// 	if (isPreview) return
	// 	const totalAmount =
	// 		selectedPaymentPlanFee?.reduce(
	// 			(sum, item) => sum + (item.finalPrice || 0),
	// 			0,
	// 		) || 0

	// 	const totalAmountAfterDiscount =
	// 		totalAmount - (realData?.application_discount?.discount || 0)

	// 	setValues({
	// 		total_amount: totalAmount,
	// 		final_payable_amount: totalAmountAfterDiscount,
	// 	})
	// }, [
	// 	isPreview,
	// 	realData?.application_discount?.discount,
	// 	selectedPaymentPlanFee,
	// 	setValues,
	// ])

	const { feeSummary, getValues } = usePayment()
	const { total_amount, final_payable_amount } = getValues() || {}
	const [open, setOpen] = useState(true)
	const fee = feeSummary.find(
		fee => fee.coupon_discount && fee.coupon_discount > 0,
	)

	//sort the fee summary components by the order in which first the isCourseFeeComponent should come first and then the isDiscountComponent and last all the isCourseFeeComponent false should come
	const sortedFeeSummary = useMemo(() => {
		return [...feeSummary].sort((a, b) => {
			const getPriority = (fee: any) => {
				if (fee.is_course_component) return 1
				if (fee.isDiscountComponent) return 2
				return 3
			}

			return getPriority(a) - getPriority(b)
		})
	}, [feeSummary])

	return (
		<>
			{/* Program Summary Dropdown */}
			<Accordion
				type="single"
				collapsible
				className="w-full"
				defaultValue="summary"
				onValueChange={value => {
					if (value === "summary") {
						setOpen(true)
					} else {
						setOpen(false)
					}
				}}
			>
				<AccordionItem
					value={"summary"}
					className="rounded-lg border"
				>
					<AccordionTrigger className="px-8 py-6 data-[state=open]:border-b">
						<div className="flex items-center gap-4">
							<ReceiptText className="size-5" />
							<h3 className="font-medium">
								Program & Fee Summary
							</h3>
						</div>
					</AccordionTrigger>
					<AccordionContent className="flex min-h-80 flex-col justify-between pb-0">
						<div className="space-y-7 p-8 @container">
							<div className="hidden grid-cols-3 @2xl:grid">
								<p className="text-sm font-medium">
									Fee category
								</p>
								<p className="text-center text-sm font-medium">
									Payment breakdown
								</p>
								<p className="text-end text-sm font-medium">
									Payable Fees (INR)
								</p>
							</div>
							<div className="space-y-3 @container">
								{sortedFeeSummary?.map(fee => {
									return (
										<div className="grid grid-cols-2 @2xl:grid-cols-3">
											<div className="grid grid-cols-1 @2xl:col-span-2 @2xl:grid-cols-2">
												<div className="flex gap-2">
													<span className="text-sm font-normal text-muted-foreground">
														{fee.name}
													</span>
													{!fee.isDiscountComponent && (
														<FrequencyChip
															frequency={
																fee.frequency
															}
														/>
													)}
												</div>
												{/* payment breakdown */}
												<span className="flex gap-1 @2xl:justify-center">
													{!fee.isDiscountComponent ? (
														<>
															<FeeFrequency
																frequency={
																	fee.frequency
																}
															/>
															x
															{
																fee
																	.price_details
																	?.length
															}
														</>
													) : (
														"-"
													)}
												</span>
											</div>
											<span className="text-sm font-semibold">
												{isPreviewMode ? (
													"N/A"
												) : (
													<div className="flex flex-col items-end justify-end gap-2 @2xl:flex-row @2xl:items-center">
														<DiscountedFee
															actualPrice={
																fee?.price || 0
															}
															discountedPrice={
																fee.finalPrice ||
																0
															}
															currency={
																fee?.currency ||
																"INR"
															}
														/>
													</div>
												)}
											</span>
										</div>
									)
								})}
							</div>
						</div>

						<div className="space-y-6 border-t px-8 py-4">
							<div className="flex items-center justify-between">
								<span className="text-sm font-bold">
									To Pay
								</span>

								<span className="text-sm font-bold">
									{isPreviewMode ? (
										"N/A"
									) : (
										<div className="flex items-center gap-2">
											<DiscountedFee
												actualPrice={total_amount}
												discountedPrice={
													final_payable_amount
												}
												currency={
													feeSummary[0]?.currency ||
													"INR"
												}
											/>
										</div>
									)}
								</span>
							</div>

							{!isPreviewMode &&
								total_amount - final_payable_amount > 0 && (
									<div className="space-y-2 rounded-2xl bg-[#E8F5EC] p-6">
										{total_amount -
											final_payable_amount -
											(fee?.coupon_discount ?? 0) >
											0 && (
											<div className="flex justify-between">
												<span className="text-[#189842]">
													Discount
												</span>
												<span className="text-[#189842]">
													{fee?.currency}{" "}
													{total_amount -
														final_payable_amount -
														(fee?.coupon_discount ??
															0)}
												</span>
											</div>
										)}
										{fee?.coupon_discount &&
											fee?.coupon_discount > 0 && (
												<div className="flex justify-between">
													<span className="text-[#189842]">
														Coupon discount
													</span>
													<span className="text-[#189842]">
														{fee?.currency}{" "}
														{fee?.coupon_discount}
													</span>
												</div>
											)}
										<div className="flex justify-between">
											<span className="font-bold text-[#189842]">
												Total Savings
											</span>
											<span className="font-bold text-[#189842]">
												{fee?.currency}{" "}
												{total_amount -
													final_payable_amount}
											</span>
										</div>
									</div>
								)}
						</div>
					</AccordionContent>
				</AccordionItem>
			</Accordion>

			{!isPreviewMode &&
				!open &&
				total_amount - final_payable_amount > 0 && (
					<div className="rounded-xl bg-[#4AB1723D] py-4">
						<p className="text-center text-lg text-[#3DA15F]">
							Yay, You're saving{" "}
							<span>
								{feeSummary[0]?.currency || "INR"}{" "}
								{total_amount - final_payable_amount}
							</span>{" "}
							on this program!
						</p>
					</div>
				)}

			{/* Admission Fee Card */}
			<div className="mt-5 rounded-lg border border-primary/50 bg-[#0070FF17] px-4 py-5">
				<div className="flex items-center justify-between">
					<div className="space-y-3">
						<h3 className="text-sm font-normal">
							{nameYourPaymentPlan}
						</h3>
						<p className="font-normal">{description}</p>
					</div>
					<div className="text-right">
						<span className="text-lg font-bold text-primary">
							{isPreviewMode ? (
								"N/A"
							) : (
								<div className="flex items-center gap-2">
									{feeSummary[0]?.currency || "INR"}{" "}
									{final_payable_amount}
								</div>
							)}
						</span>
					</div>
				</div>
			</div>
		</>
	)
}

export default Summary

export function FrequencyChip({ frequency }: { frequency: string }) {
	switch (frequency) {
		case "ONE_TIME":
			return (
				<p className="h-fit rounded-full bg-[#EC003F1C] px-1.5 py-1 text-xs text-[#EC003F]">
					One-time
				</p>
			)

		case "PER_YEAR":
			return (
				<p className="h-fit rounded-full bg-[#76D2751F] px-1.5 py-1 text-xs text-[#189842]">
					Per-Year
				</p>
			)

		case "PER_SEMESTER":
			return (
				<p className="h-fit rounded-full bg-[#76D2751F] px-1.5 py-1 text-xs text-[#189842]">
					Per-semester
				</p>
			)
	}
}

export function FeeFrequency({ frequency }: { frequency: string }) {
	switch (frequency) {
		case "ONE_TIME":
			return <p>One-time</p>

		case "PER_YEAR":
			return <p>Per-Year</p>

		case "PER_SEMESTER":
			return <p>Per-semester</p>
	}
}
